/**
 * Entry path into the booking flow after the landing page or a skip URL.
 *
 * Desktop lands directly on the results page (`explore`), where parameters are
 * set inline via the open-search header. Mobile has no inline header to set
 * parameters with, so it goes to the filters page first.
 *
 * Returned values are React Router *relative* path segments. Callers that
 * navigate from outside the restaurant subtree (e.g. building an absolute
 * `/${slug}/...` link) must prepend their own prefix.
 */
export function getExploreEntryPath(isSmallScreen: boolean): 'explore' | 'explore/filters' {
	return isSmallScreen ? 'explore/filters' : 'explore';
}
